// What each column means, shown on hover of the info icon beside the column title.
// Only the columns whose meaning is not obvious from their title carry an icon.

export const EXCALIBUR_COLUMN_INFO = {
    status: "Current status of the request.",
    inputFileKey: "File uploaded by the user.",
    generatedFileKey: "The report generated from the uploaded file.",
    txnArtifacts: "Supporting files for this request."
};

export const FILING_COLUMN_INFO = {
    taxIdentifier: "Invoice number or entity code for each filing.",
    status: "Current status of the filing.",
    inputFileKey: "File uploaded by the user.",
    getReceipt: "Proof of submission for this entity.",
    txnArtifacts: "Supporting files for this request."
};

export const TASK_COLUMN_INFO = {
    taskId: "Unique id of this entity's task within the transaction.",
    taxIdentifier: "Invoice number or entity code for each filing.",
    status: "Outcome for this entity.",
    taskInputFile: "File uploaded by the user.",
    taskInputFileFromReport: "The input file used for this entity.",
    submissionReceipt: "Proof of submission for this entity.",
    generatedReport: "The report produced for this entity from its input."
};

// What each status value means, listed in the Status column's info tooltip; order is roughly the lifecycle.

export const EXCALIBUR_STATUS_INFO = [
    ["INQUEUE", "Request queued, not started yet."],
    ["PROCESSING", "Report generation running."],
    ["SUCCESS", "Report generated, no validation errors."],
    ["CONDITIONAL_SUCCESS", "Report generated, some rows failed pre-validation, see the error report."],
    ["FAILURE", "Generation failed, error report may exist."],
    ["EXCEPTION", "Internal error stopped the run."]
];

export const FILING_STATUS_INFO = [
    ["PROCESSING", "Filing accepted and running."],
    ["SUCCESS", "Every entity filed and accepted."],
    ["PARTIAL_SUCCESS", "Some entities filed, some failed."],
    ["FAILURE", "Filing failed for all entities."],
    ["EXCEPTION", "Internal error stopped the run."],
    ["TRANSMISSION_COMPLETED", "Submitted to downstream."],
    ["PARTIAL_TRANSMISSION_COMPLETED", "Only some entities of the file could be submitted."],
    ["ACCEPTED_WITH_ERRORS", "Authority accepted the submission but reported errors."],
    ["ERROR", "Authority failed to process the submission."],
    ["SUBMITTED", "Submitted to the authority."]
];

export const EXCALIBUR_TASK_STATUS_INFO = [
    ["PROCESSING", "Report generation started."],
    ["SUCCESS", "This entity's file was generated."],
    ["FAILURE", "This entity failed."]
];

export const FILING_TASK_STATUS_INFO = [
    ["PROCESSING", "Transaction is being processed."],
    ["SUCCESS / ACCEPTED / AUTHORIZED", "This entity was filed and accepted."],
    ["FAILURE / REJECTED", "This entity failed."],
    ["TRANSMISSION_COMPLETED", "Submitted to downstream."],
    ["SUBMITTED", "Submitted to the authority."],
    ["WARNING", "Authority accepted this entity with warnings."],
    ["ERROR", "Authority failed to process this entity."]
];
